module.exports = __webpack_public_path__ + "static/img/mirror.69e717ad.png";